import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseDeletePrivateCompanyLeadGenericDocumentProps {
  privateCompanyLeadId?: string
  onSuccess?: (response: any) => void
  onError?: (error: any) => void
}

export const useDeletePrivateCompanyLeadGenericDocument = ({ privateCompanyLeadId, onSuccess, onError }: UseDeletePrivateCompanyLeadGenericDocumentProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['deletePrivateCompanyLeadGenericDocument'],
    mutationFn: (attachment_id: string) => {
      const private_company_lead = {
        generic_documents_attachments_attributes: [
          {
            id: attachment_id,
            _destroy: true,
          }
        ]
      }

      return privateAxios.put(`/funnel/private_company_leads/${privateCompanyLeadId}`, {
        private_company_lead
      })
    },
    onSuccess,
    onError,
  })
}
